import gql from 'graphql-tag';

// TODO - add correct query once data mapping is done
export const ACCOUNT_MINIMUMS = gql`
    query AccountMinimums($ticker: String!) {
        mutualFund(ticker: $ticker) {
            Strategy: strategyText
            minimumInvestmentAmount
            accountMinimumAddToAccount
            accountMinimumOpenIRA
            accountMinimumAddToIRA
            accountMinimumSystematicPurchase
        }
    }
`;

// TODO - add correct query once data mapping is done
export const NO_LOAD_FUND = gql`
    query FeesExpenses($ticker: String!) {
        mutualFund(ticker: $ticker) {
            Strategy: strategyText
            frontEndLoad
            backEndLoad
            loadHistoryText
        }
    }
`;
